































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Icon, Accordion } from '@/pages/profile/components';
import { INotificationsCard } from './types';

@Component({
  components: {
    Icon,
    Accordion,
  },
})
export default class NotificationsCard
  extends Vue
  implements INotificationsCard {
  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly date!: string;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly message!: string;

  @Prop({ type: String, default: 'N' })
  readonly isRead!: string;

  opened: boolean = false;
  viewed: boolean = this.isRead === 'Y';

  get toggleText(): string {
    const { opened } = this;
    return opened ? 'свернуть' : 'показать полностью';
  }

  get longMessage(): boolean {
    return this.message.length > 200;
  }

  readNotification(): void {
    this.viewed = true;
    this.$emit('notificationViewed', this.id);
  }

  toggle(): void {
    this.opened = !this.opened;
    if (!this.viewed) this.readNotification();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/notification/blocks/card/Card.vue